import './styles.scss'

import React, { Component } from 'react'

export default class Index extends Component {
  render() {
    // const { icon, text } = this.props;
    return <button className='whatsapp-login-button' onClick={() => this.props.callback(null, 'whatsapp')} />
  }
}
